import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './tufts-icon-button.css.lit';

/**
 * The TuftseContainer component
 * @element tufts-icon-button
 *
 * @slot - label
 * @slot - icon
 *
 * @attr url
 */
@customElement('tufts-icon-button')
export class TuftsIconButton extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String, reflect: true, attribute: true })
  url: string;

  render(): TemplateResult {
    return html`
      <a href="${this.url}" class="tufts-icon-button">
        <div class="icon">
          <slot aria-hidden="true" name="icon"></slot>
        </div>
        <div class="label">
          <slot name="label"></slot>
        </div>
      </a>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-icon-button': TuftsIconButton;
  }
}
